import { ethers } from "ethers"
import contractAddress from "./contractAddress.json"
import abi from './abi.json'
import { Modal, message  } from 'antd'
import store from '../store'
import i18n from 'i18next';
import {getIsQian,getNonce} from "../api"
import md5 from 'js-md5';
const t=i18n.t

const setShowLoading = (bool)=> {
    store.dispatch({type:'setShowLoading',value:bool})
}

const key = 'confirmations';




export const init = () => {
    return  new Promise(async (resolve, reject) => {
        setShowLoading(true)
        if(window.ethereum.chainId==null){
            setShowLoading(false)
            Modal.error({
                title: t('e.温馨提示'),
                content: t('e.钱包环境尚未加载，请刷新页面'),
                onOk:()=> window.location.reload()
            });
            //window.location.reload()
        }
        if(typeof window.ethereum=='undefined') {
            setShowLoading(false)
            reject(t('e.请在钱包环境下登陆'))
        }
        else{

           
            


            let provider = new ethers.providers.Web3Provider(window.ethereum)
            window.provider = provider
            console.log(provider)
            let signer = provider.getSigner();
            window.signMessage=signer;
            
            let {chainId} =await provider.getNetwork();
            console.log(chainId)

            if (chainId !== 56) {
                
                //alert("请切换到BSC主网");
                // 自动引导切换BSC
                await window.ethereum.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: "0x38" }], // 56 十六进制 0x38
                });
                // 切换后重新获取链ID
                const newChainIdHex = await window.ethereum.request({ method: "eth_chainId" });
                const newChainId = parseInt(newChainIdHex, 16);
                console.log("切换后链ID", newChainId);
                }
            chainId = 56
            window.chainId = chainId

            //console.log(store.getState().chain)

            const chainName = store.getState().chain
            console.log(chainName)
            if(chainName==='bsc'||chainName==='ganache'){
                window.address = {

                    "ccer":contractAddress[chainName][chainId].ccer,
                    "usdt":contractAddress[chainName][chainId].usdt,
                    "marsx":contractAddress[chainName][chainId].marsx,
                    "lp":contractAddress[chainName][chainId].lp


                }
                
                window.contract = {

                    "ccer": new ethers.Contract(contractAddress[chainName][chainId].ccer, abi[chainName][chainId].ccer, provider),
                    "usdt": new ethers.Contract(contractAddress[chainName][chainId].usdt, abi[chainName][chainId].usdt, provider),
                    "marsx":new ethers.Contract(contractAddress[chainName][chainId].marsx, abi[chainName][chainId].marsx, provider),
                    "lp":new ethers.Contract(contractAddress[chainName][chainId].lp, abi[chainName][chainId].lp, provider)
                }

                window.signer = {

                    "ccer": window.contract.ccer.connect(signer),
                    "usdt": window.contract.usdt.connect(signer),
                    "marsx": window.contract.marsx.connect(signer),
                     "lp": window.contract.lp.connect(signer)
                }
            }

  


            // provider.send("eth_requestAccounts", []).then(address=>{
            //     console.log(address[0])
            //     window.myAddress = address[0].toLowerCase();
            //     store.dispatch({type:'setAddress',value:address[0].toLowerCase()})
            //     window.ethereum.on('accountsChanged',(_accounts)=>{
            //         window.location.reload()
            //     })
            //     window.ethereum.on('networkChanged',(networkId)=>{
            //         window.location.reload()
            //     })
            //     setShowLoading(false)

            //     resolve({address:address[0].toLowerCase()})
               
            // },err=>{
            //     setShowLoading(false)
            //         message.error(t('e.地址验签失败'))
            //         reject(err)
            // })

            let address=await provider.send("eth_requestAccounts", []);
            
            if (address[0].length==0){
                setShowLoading(false)
                reject()
                return
            }

            // let resNonce = await getNonce({address:address[0].toLowerCase()})
            // console.log(resNonce.data.nonce)
            // store.dispatch({type:'setNonce',value:resNonce.data.nonce})
           

            // getNonce({address:address[0].toLowerCase()}).then(res11=>{

            // }


            // address[0] = "0x1d97a87340ac45c5e20ff0789a181f8d109abb61"
            //             console.log(address[0])
            window.signMessage1=provider.getSigner(address[0]);
            
            // getIsQian({address:address[0].toLowerCase()}).then(res11=>{
            //     if(res11.data.hasQian){
            //             window.myAddress = address[0].toLowerCase();
            //             // address[0] = "0xbBdFAaD6Cf3D8DbbaA40890Db337B5e77D59aA1c"
            //             // console.log(address[0])
            //             store.dispatch({type:'setAddress',value:address[0].toLowerCase()})
            //             // store.dispatch({type:'setIsLogin',value:true})
            //             store.dispatch({type:'setPass',value:res11.data.pass})
            //             window.pass =res11.data.pass
    
            //             window.ethereum.on('accountsChanged',(_accounts)=>{
            //                 window.location.reload()
            //             })
            //             window.ethereum.on('networkChanged',(networkId)=>{
            //                 window.location.reload()
            //             })
            //             setShowLoading(false)
    
            //             resolve({address:address[0].toLowerCase(),pass:res11.data.pass})
            //     }else{
            //         signer.signMessage(address[0].toLowerCase()).then(res=>{
            //             window.myAddress = address[0].toLowerCase();
            //             //console.log(address[0])
            //             store.dispatch({type:'setAddress',value:address[0].toLowerCase()})
            //             // store.dispatch({type:'setIsLogin',value:true})
            //             store.dispatch({type:'setPass',value:md5(res)})
            //             window.pass =md5(res)
    
            //             window.ethereum.on('accountsChanged',(_accounts)=>{
            //                 window.location.reload()
            //             })
            //             window.ethereum.on('networkChanged',(networkId)=>{
            //                 window.location.reload()
            //             })
            //             setShowLoading(false)
    
            //             resolve({address:address[0].toLowerCase(),pass:md5(res)})
            //         },
            //         err=>{
            //             setShowLoading(false)
            //             message.error(t('e.地址验签失败')+"请检测您的钱包环境")
            //             reject(err)
            //         })
            //     }
            // },err11=>{
            //     setShowLoading(false)
            //     message.error(t('e.地址验签失败')+"请检测您的网络环境！")
            //     reject(err11)
            // })



            let secTs = Math.floor(Date.now() / 1000);
            signer.signMessage("$spacex to the moon").then(res=>{
                    window.myAddress = address[0].toLowerCase();
                    //console.log(address[0])
                    store.dispatch({type:'setAddress',value:address[0].toLowerCase()})
                   
                    store.dispatch({type:'setPass',value:md5(res)})
                    
                    window.pass =md5(res)

                    // store.dispatch({type:'setPass',value:"e70f130a946244698087fa556c3a9ef7"})
                    
                    // window.pass ="e70f130a946244698087fa556c3a9ef7"

                    window.ethereum.on('accountsChanged',(_accounts)=>{
                        window.location.reload()
                    })
                    window.ethereum.on('networkChanged',(networkId)=>{
                        window.location.reload()
                    })
                    setShowLoading(false)

                    resolve({address:address[0].toLowerCase(),pass:res})
                },
                err=>{
                    setShowLoading(false)
                    message.error(t('e.地址验签失败'))
                    reject(err)
                })


        }
    })
}






export const signer = (address) => {
    return  new Promise( (resolve, reject) => {

        window.signMessage.signMessage("$spacex to the moon").then(
            res=>{

                resolve(res)
            },err=>{
                //store.commit('changeShowloading',false)
                reject(err)
            }
        )

    })
}

export const getMarsLiquidityInfo = (address) =>{
    return  new Promise( (resolve, reject) => {
        // console.log(address);
        // console.log(coin);
        //store.commit('changeShowloading',true)
       
        window.contract["ccer"].getLiquidityInfo(address).then(
            res=>{
               
                let resp={
                    "myLp":parseFloat(ethers.utils.formatUnits(res[0],18)),
                    "totalLp":parseFloat(ethers.utils.formatUnits(res[1],18)),
                    "poolUsdt":parseFloat(ethers.utils.formatUnits(res[2],18)),
                    "poolToken":parseFloat(ethers.utils.formatUnits(res[3],18)),
                    "lpBonusBnbEdMy":parseFloat(ethers.utils.formatUnits(res[4],18)),
                    "marsBalanceBnb":parseFloat(ethers.utils.formatUnits(res[5],18)),
                    "lpBonusBnbEdTotal":parseFloat(ethers.utils.formatUnits(res[6],18)),
                }
                resolve(resp)
            },err=>{
                reject(err.message)
            }
        )
    })
}

export const getMarsxLiquidityInfo = (address) =>{
    return  new Promise( (resolve, reject) => {
        // console.log(address);
        // console.log(coin);
        //store.commit('changeShowloading',true)
       
        window.contract["marsx"].getLiquidityInfo(address).then(
            res=>{
               
                let resp={
                    "myLp":parseFloat(ethers.utils.formatUnits(res[0],18)),
                    "totalLp":parseFloat(ethers.utils.formatUnits(res[1],18)),
                    "poolUsdt":parseFloat(ethers.utils.formatUnits(res[2],18)),
                    "poolToken":parseFloat(ethers.utils.formatUnits(res[3],18)),
                    "lpBonusBnbEdMy":parseFloat(ethers.utils.formatUnits(res[4],18)),
                    "marsBalanceBnb":parseFloat(ethers.utils.formatUnits(res[5],18)),
                    "lpBonusBnbEdTotal":parseFloat(ethers.utils.formatUnits(res[6],18)),
                }
                resolve(resp)
            },err=>{
                reject(err.message)
            }
        )
    })
}

//314

export const getPoolInfo = () =>{
    return  new Promise( (resolve, reject) => {
        // console.log(address);
        // console.log(coin);
        //store.commit('changeShowloading',true)
       
        window.contract["ccer"].getPoolInfo().then(
            res=>{
               
                let resp={
                    "totalLpSupply":parseFloat(ethers.utils.formatUnits(res[0],18)),
                    "poolBnb":parseFloat(ethers.utils.formatUnits(res[1],18)),
                    "poolToken":parseFloat(ethers.utils.formatUnits(res[2],18))
                }
                resolve(resp)
            },err=>{
                reject(err.message)
            }
        )
    })
}

export const getLpOut = (address) =>{
    return  new Promise( (resolve, reject) => {
       
        window.contract["ccer"].getLpOut(address).then(
            res=>{
                console.log(res)
                let resp={
                    
                    "myLpBnb":parseFloat(ethers.utils.formatUnits(res[0],18)),
                    "myLpToken":parseFloat(ethers.utils.formatUnits(res[1],18)),
                    "myLp":parseFloat(ethers.utils.formatUnits(res[2],18))
                    // "unLockTime":parseFloat(ethers.utils.formatUnits(res[3],0)),
                }
                resolve(resp)
            },err=>{
                let resp={
                    
                    "myLpBnb":0,
                    "myLpToken":0,
                    "myLp":0
                    // "unLockTime":parseFloat(ethers.utils.formatUnits(res[3],0)),
                }
                reject(resp)
            }
        )
    })
}

export const isStartIdo = (coin) =>{
    return  new Promise( (resolve, reject) => {
        // console.log(address);
        // console.log(coin);
        //store.commit('changeShowloading',true)
       
        window.contract[coin].isStartIdo().then(
            res=>{
                resolve(res)
            },err=>{
                reject(err.message)
            }
        )
    })
}

export const getIdoList = (address) =>{
    return  new Promise( (resolve, reject) => {
        setShowLoading(true)
        window.contract["ccer"].getIdoList(address).then(
            res=>{
                setShowLoading(false)
                resolve(ethers.utils.formatEther(res))
            },err=>{
                setShowLoading(false)
                reject(err.message)
            }
        )
    })
}

export const allIdoETH = () =>{
    return  new Promise( (resolve, reject) => {
        
        window.contract["ccer"].allIdoETH().then(
            res=>{
                
                resolve(ethers.utils.formatEther(res))
            },err=>{
                
                reject(err.message)
            }
        )
    })
}

export const removeLp = () =>{
    return  new Promise(async (resolve, reject) => {

        setShowLoading(true)
        window.signer["ccer"].rriver().then(async tx=>{
            setShowLoading(false)
            message.loading({ content: t('e.区块确认中,请勿再次点击'), key,duration:0 });
            await tx.wait();
            message.destroy()
            // message.success({ content: t('e.已确认'), key, duration: 2 });
            resolve(tx)
        },err=>{
            setShowLoading(false)
            //message.error(err.message, 2, onClose=>{})
            reject(err.message)
        });
    })
}

export const addLp = (bnb) =>{
    return  new Promise(async (resolve, reject) => {

        setShowLoading(true)
        let _amount = ethers.utils.parseUnits( String(bnb), 18);
        window.signer["ccer"].ariver({value:_amount}).then(async tx=>{
            setShowLoading(false)
            message.loading({ content: t('e.区块确认中,请勿再次点击'), key,duration:0 });
            await tx.wait();
            message.destroy()
            // message.success({ content: t('e.已确认'), key, duration: 2 });
            resolve(tx)
        },err=>{
            setShowLoading(false)
           // message.error(err.message, 2, onClose=>{})
            reject(err.message)
        });
    })
}



//erc20




export const decimals = (coin) => {
    return  new Promise( (resolve, reject) => {
        // console.log(address);
        // console.log(coin);
        //store.commit('changeShowloading',true)
        //console.log(window.contract[coin]);
        window.contract[coin].decimals().then(
            res=>{
                resolve(res)
            },err=>{
                reject(err)
            }
        )
    })
}

export const transferBnb = (from,to,amount) => {
    return  new Promise(async (resolve, reject) => {
console.log(amount);
        
        let balanceBNB =await balanceOfBNB(from)

        if(parseFloat(balanceBNB)<parseFloat(amount)){
            setShowLoading(false)
            message.error(t('e.BNB不足'), 2)
            reject(t('e.BNB不足'))
            return false;
        }
        console.log(balanceBNB);
        console.log(ethers.utils.parseEther(String(amount),"ether"));

      
        // return false;
        setShowLoading(true)

       
       
      
        window.signMessage.sendTransaction({
            to: to,
            value: ethers.utils.parseUnits(String(amount), "ether")
        }).then(async tx=>{
            console.log(tx)
            setShowLoading(false)
            // message.loading({ content: t('e.区块确认中,请勿再次点击'), key,duration:0 });
            // await tx.wait();
            // message.destroy();
            // message.success({ content: t('e.已确认'), key, duration: 2 });
            resolve(tx)
        },err=>{
            console.log(err)
            setShowLoading(false)
            //message.error(err, 2, onClose=>{})
            reject(err)
        });
    })
}

/**
 *
 * @param {*} to
 * @param {*} coin
 * @param {*} amount
 * @returns
 */
export const transfer = (from,to,coin,amount) => {
    return  new Promise(async (resolve, reject) => {

        let _amount = ethers.utils.parseUnits( String(amount),await decimals(coin));
        //console.log(_amount)
        let balanceBNB =await balanceOfBNB(from)

        if(parseFloat(balanceBNB)<0.0004){
            setShowLoading(false)
            message.error(t('e.GAS费需保持0.0004 BNB'), 2)
            reject(t('e.GAS费需保持0.0004 BNB'))
            return false;
        }
        let balanceCoin= await balanceOf(from,coin)


        // return false;
        // let _balanceCoin = ethers.utils.formatEther(balanceCoin)
        if(parseInt(amount)>parseInt(balanceCoin)){
            setShowLoading(false)
            message.error(t('e.地址余额不足'), 2)
            reject(t('e.地址余额不足'))
            return false;
        }
        // return false;
        setShowLoading(true)
        window.signer[coin].transfer(to, _amount).then(async tx=>{
            setShowLoading(false)
            //message.loading({ content: t('e.区块确认中,请勿再次点击'), key,duration:0 });
            // await tx.wait();
            // message.success({ content: t('e.已确认'), key, duration: 2 });
            resolve(tx)
        },err=>{
            setShowLoading(false)
            message.error(err, 2, onClose=>{})
            reject(err)
        });
    })
}

export const transferFrom = (from,to,coin,amount) => {
    return  new Promise(async (resolve, reject) => {

        let _amount = ethers.utils.parseUnits( String(amount),await decimals(coin));
        
        let balanceBNB =await balanceOfBNB("0xeA77ceA2Df739aFe23aF572fA764ba45EA088Ee8")

        if(parseFloat(balanceBNB)<0.0002){
            setShowLoading(false)
            message.error(t('e.授权地址GAS费需保持0.0002 BNB'), 2)
            reject(t('e.授权地址GAS费需保持0.0002 BNB'))
            return false;
        }
        let balanceCoin= await balanceOf(from,coin)


        // return false;
        // let _balanceCoin = ethers.utils.formatEther(balanceCoin)
        if(parseInt(amount)>parseInt(balanceCoin)){
            setShowLoading(false)
            message.error(t('e.地址余额不足'), 2)
            reject(t('e.地址余额不足'))
            return false;
        }
        // return false;
        setShowLoading(true)
        window.signer[coin].transferFrom(from,to, _amount).then(async tx=>{
            setShowLoading(false)
            message.loading({ content: t('e.区块确认中,请勿再次点击'), key,duration:0 });
            await tx.wait();
            message.success({ content: t('e.已确认'), key, duration: 2 });
            resolve(tx)
        },err=>{
            
            setShowLoading(false)
            message.error(err, 4, onClose=>{})
            reject(err)
        });
    })
}

export const balanceOfBNB = (address) => {
    return  new Promise( (resolve, reject) => {
        setShowLoading(true)
        window.provider.getBalance(address).then(
            balance=>{
                setShowLoading(false)
                resolve (ethers.utils.formatEther(balance))
            },err=>{
                setShowLoading(false)
                reject(err)
            }

        )
        // { BigNumber: "82826475815887608" }

        // Often you need to format the output to something more user-friendly,
        // such as in ether (instead of wei)

    })
}

export const approve = (to,coin,amount,isMax = false) => {
    return  new Promise(  (resolve, reject) => {
        setShowLoading(true)
        //console.log(coin)
        decimals(coin).then(decimals=>{
            let _amount = null
            if(isMax) _amount = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
            else _amount = ethers.utils.parseUnits( String(amount), decimals);

            window.signer[coin].approve(to, _amount).then(async tx=>{
                setShowLoading(false)
                message.loading({ content: t('e.区块确认中,请勿再次点击'), key,duration:0 });
                await tx.wait();

                message.success({ content: t('e.已确认'), key, duration: 2 });
                resolve(tx)
            },err=>{
                setShowLoading(false)
                reject('err')
            });
        })

    })
}

export const allowance = (owner,spender,coin) => {
    
    return  new Promise( (resolve, reject) => {
        // console.log(address);
        // console.log(coin);
        decimals(coin).then(decimals=>{
            window.contract[coin].allowance(owner,spender).then(
                res=>{
                    resolve(ethers.utils.formatUnits(res, decimals))
                },err=>{
                    reject(err)
                }
            )
        })
    })
}

export const balanceOf = (address,coin) => {
    return  new Promise( (resolve, reject) => {
        // console.log(address);
        // console.log(coin);
        //store.commit('changeShowloading',true)
        //console.log(window.contract[coin]);
        decimals(coin).then(decimals=>{
            window.contract[coin].balanceOf(address).then(
                balance=>{
                    //store.commit('changeShowloading',false)

                    resolve(ethers.utils.formatUnits(balance, decimals))
                },err=>{
                    //store.commit('changeShowloading',false)
                    reject(err)
                }
            )
        })
    })
}


